import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import { passwordStrength } from '../lib/passwordStrength';

// Farba k hodnoteniu. Samotné hodnotenie je v `lib/passwordStrength.ts`, aby
// sa dalo otestovať bez vykresľovania.
const STRENGTH_TONE = [
  'bg-rose-500',
  'bg-rose-400',
  'bg-amber-400',
  'bg-lime-400',
  'bg-emerald-500',
];

export const PasswordField = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  autoComplete = 'new-password',
  disabled,
  showStrength = false,
  autoFocus = false,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoComplete?: string;
  disabled?: boolean;
  showStrength?: boolean;
  autoFocus?: boolean;
}) => {
  const [visible, setVisible] = useState(false);
  const strength = passwordStrength(value);
  return (
    <div>
      <label className="label" htmlFor={id}>
        {label}
      </label>
      <div className="relative">
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          className="input pr-11"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          disabled={disabled}
        />
        <button
          type="button"
          className="absolute inset-y-0 right-0 grid w-11 place-items-center text-slate-400 transition hover:text-slate-600 dark:hover:text-slate-200"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Skryť heslo' : 'Zobraziť heslo'}
          tabIndex={-1}
        >
          {visible ? <EyeSlashIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}
        </button>
      </div>
      {showStrength && value ? (
        <div className="mt-1.5 space-y-1">
          <div className="flex items-center gap-2">
            <div className="flex h-1 flex-1 gap-1" aria-hidden="true">
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className={`flex-1 rounded-full transition ${
                    i <= Math.max(1, strength.score)
                      ? STRENGTH_TONE[strength.score]
                      : 'bg-black/[0.08] dark:bg-white/10'
                  }`}
                />
              ))}
            </div>
            {/* Text nesie tú istú informáciu ako pruhy — farba sama o sebe nie
                je informácia pre každého. */}
            <span className="w-16 shrink-0 text-right text-[11px] text-slate-400">
              {strength.label}
            </span>
          </div>
          {strength.hint ? (
            <p className="text-[11px] text-slate-400 dark:text-slate-500" role="status">
              {strength.hint}
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
